// ipad-pwa/src/components/AlphaNumPad.jsx
// On-screen alphanumeric keypad used for pairing-code entry. Mirrors the
// backend's unambiguous alphabet (server/src/routes/devices.js):
//   ABCDEFGHJKLMNPQRSTUVWXYZ + 23456789
// — I/O/0/1 are deliberately excluded so admins typing codes aloud or
// reading them off paper don't trip on look-alikes.

const LETTERS = ['ABCDEFGH', 'JKLMNPQR', 'STUVWXYZ'];
const DIGITS = '23456789';

export default function AlphaNumPad({ onKey, onBackspace, onClear, maxLen, value }) {
  const Btn = ({ label, onClick, variant = 'default', wide }) => {
    const styles = {
      default: 'bg-white hover:bg-slate-100 active:bg-slate-200 text-slate-800',
      danger: 'bg-slate-200 hover:bg-slate-300 active:bg-slate-400 text-slate-700',
    };
    return (
      <button
        type="button"
        onClick={onClick}
        className={
          'h-14 rounded-xl border border-slate-200 text-2xl font-semibold shadow-sm transition ' +
          styles[variant] +
          (wide ? ' col-span-2' : '')
        }
      >
        {label}
      </button>
    );
  };

  const press = (k) => {
    if (maxLen && value && value.length >= maxLen) return;
    onKey(k);
  };

  return (
    <div className="space-y-2 select-none w-full max-w-xl mx-auto">
      {LETTERS.map((row, i) => (
        <div key={i} className="grid grid-cols-8 gap-2">
          {row.split('').map((ch) => (
            <Btn key={ch} label={ch} onClick={() => press(ch)} />
          ))}
        </div>
      ))}
      <div className="grid grid-cols-8 gap-2">
        {DIGITS.split('').map((ch) => (
          <Btn key={ch} label={ch} onClick={() => press(ch)} />
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Btn label="Clear" onClick={onClear} variant="danger" />
        <Btn label="← Back" onClick={onBackspace} variant="danger" />
      </div>
    </div>
  );
}
